import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Select from "react-select";
import ReactPaginate from "react-paginate";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AddDictionary } from "./modal"
import { Footer } from "../../../layout/footer"
import { options } from "../../../api";
import { dictionaryCRUD } from "../../../actions/dictionary"
import { Loading } from "../../constant";
import { EditDictionary } from "./editModal";
import { UploadDictionary } from "./upload";

export const DictionaryContent = () => {

  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0)
  const [value, setValue] = useState('')
  const [index, setIndex] = useState(0)
  const [dataId, setDataId] = useState(null)
  const [deleteId, setDeleteId] = useState(null)

  useEffect(() => {
    setTimeout(() => {
      dictionaryCRUD.loadDictionary(postsPerPage, nextPage, value).then((resp) => {
        setCount(resp.data.count)
        setData(resp.data.results)
        setPageCount(Math.ceil(resp.data.count / postsPerPage))
      }).finally(() => {})
    }, 2000)

  }, [page, postsPerPage, value, index])

  const handleChangePage = (event) => {
    setData([])
    setPage(event.selected);
    setNextPage(event.selected * postsPerPage);
  };

  const handleChange = selectedOption => {
    setData([])
    const sel = selectedOption.value;
    setePostPerPage(sel);
    setNextPage(0);
    setPage(0)
  };

  const handleSearch = (event) => {
    setData([])
    setValue(event.target.value)

  }

  const handleChangeId = (e) => {
    setDataId(e)
  }

  const handleDelete = () => {
    if (deleteId) {
      dictionaryCRUD.deleteDictionary(deleteId)
        .then(() => {
          toast.success("Dictionary deleted successfully!", { position: "top-right" });
          setIndex(index + 1); // Refresh the data
          setDeleteId(null);
        })
        .catch((error) => {
          const errorMessage = error.response?.data?.error || "Failed to delete dictionary";
          toast.error(errorMessage, { position: "top-right" });
          setDeleteId(null);
        });
    }
  }

  return (

    <>
      <ToastContainer />
      <AddDictionary setIndex={setIndex} index={index}/>
      <EditDictionary dataId={dataId} setIndex={setIndex} index={index}/>
      <UploadDictionary setIndex={setIndex} index={index}/>

      {/* Delete Confirmation Modal */}
      <div className="modal fade" id="deleteModal" tabIndex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteModalLabel">Confirm Delete</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this dictionary?</p>
              <p className="text-danger"><small>This action cannot be undone. Make sure there are no dictionary items associated with this dictionary.</small></p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={handleDelete}>Delete</button>
            </div>
          </div>
        </div>
      </div>
      <div class="main-content">
        <div class="page-content">
          <div class="container-fluid">

            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0">Dictionary</h4>

                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a href="#">Dictionary</a></li>
                      <li class="breadcrumb-item active">List</li>
                    </ol>
                  </div>

                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-header">

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                      <div className="col-md-3">
                                          <div className="d-flex justify-content-sm-start">
                                            <div className="search-box ms-2">
                                                <input type="text" className="form-control search" value={value} onChange={handleSearch} placeholder="Search..."/>
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                          </div>
                                      </div>
                                      <div className="col-md-6"></div>
                                      <div className="col-md-3">
                                        <div className="row d-flex justify-content-end">
                                          <div className="col-auto">
                                              <Link to={'/new'} className="btn btn-soft-primary" data-bs-toggle="modal" data-bs-target=".addModal">
                                                <i className="bi bi-plus-circle bi-lg"></i> &nbsp; New Dictionary
                                              </Link>
                                          </div>
                                          <div className="col-auto">
                                              <Link to={'#'} className="btn btn-soft-info" data-bs-toggle="modal" data-bs-target=".uploadDictionaryModal">
                                                <i className="bi bi-upload bi-lg"></i> &nbsp; Upload CSV
                                              </Link>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <table id="scroll-vertical" className="table table-bordered dt-responsive nowrap table-striped align-middle mdl-data-table" style={{width:"100%"}}>
                                        <thead>
                                            <tr>
                                                <th data-ordering="true">SR No.</th>
                                                <th data-ordering="true">Code</th>
                                                <th data-ordering="true">English Name</th>
                                                <th data-ordering="true">Swahili Name</th>
                                                <th className="d-flex justify-content-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                          {data?.map((dt, i) => (
                                              <tr key={i}>
                                                <td>{i+1}</td>
                                                <td>{dt.dictionary_code ? dt.dictionary_code : 'N/A'}</td>
                                                <td>{dt.dictionary_name_en ? dt.dictionary_name_en : 'N/A'}</td>
                                                <td>{dt.dictionary_name_sw ? dt.dictionary_name_sw : 'N/A'}</td>
                                                <td className="d-flex justify-content-center">
                                                    <div className="hstack gap-3 fs-15">
                                                        <Link to={'/new'} onClick={() => handleChangeId(dt.id)} data-bs-toggle="modal" data-bs-target=".editModal" className="btn btn-sm btn-soft-warning"><i className="bi bi-pencil-square"></i></Link>
                                                        <button onClick={() => setDeleteId(dt.id)} data-bs-toggle="modal" data-bs-target="#deleteModal" className="btn btn-sm btn-soft-danger"><i className="bi bi-trash"></i></button>
                                                    </div>
                                                </td>
                                              </tr>
                                            ))
                                          }
                                        </tbody>
                                    </table>
                                    <div className="row">
                                      {!data.length && <Loading/>}
                                    </div>
                                    <div className="row">
                                      <div className="col-md-2">
                                        <p><span>Showing </span><span>{data.length}</span> of <span>{count}</span> entries</p>
                                      </div>
                                      <div className="col-md-5">

                                      </div>
                                      <div className="col-md-5">
                                      <div className="row g-2 justify-content-start justify-content-md-end align-items-center">
                                          <div className="col-auto" style={{marginTop: -8}}>
                                            <Select options = {options} defaultValue={options[1]} onChange={handleChange} />
                                          </div>
                                          <div className="col-auto paginate" >
                                          <ReactPaginate
                                            previousLabel={<i className="las la-angle-double-left la-lg"></i>}
                                            nextLabel={<i className="las la-angle-double-right la-lg"></i>}
                                            breakLabel={"..."}
                                            breakClassName={"break-me"}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            pageCount={pageCount}
                                            onPageChange={handleChangePage}
                                            containerClassName={"pagination"}
                                            subContainerClassName={"pages pagination"}
                                            activeClassName={"active"} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
            </div>
            </div>
            </div>                               
          </div>
        </div>
        <Footer />
      </div>
    </>

  )

}